<template>
  <Layout tituloPagina="Sistema | Ajustes | Plantillas de facturación">
    <!-- Pestañas de navegación de facturación -->
    <div class="row mb-2">
      <div class="col-lg-4">
        <CmpTabs />
      </div>
    </div>

    <!-- Tarjeta Principal -->
    <div class="card shadow-sm">
      <!-- Encabezado de la tarjeta -->
      <div class="card-header justify-content-between d-flex align-items-center border-bottom">
        <div>
          <h4 class="card-title mb-1 d-flex align-items-center">
            <i class="mdi mdi-receipt-text-outline text-primary me-2 font-size-22"></i>
            Plantillas de Facturación
          </h4>
          <p class="text-muted mb-0 font-size-13">
            Personaliza el formato, diseño visual y configuración de columnas para la emisión e impresión de facturas.
          </p>
        </div>
        <div>
          <div class="dropdown">
            <a
              class="dropdown-toggle"
              href="javascript: void(0);"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <eva-icon
                name="more-horizontal-outline"
                data-eva-width="20"
                data-eva-height="20"
                :class="{
                  'fill-dark': $store.state.layout.layoutMode == 'light',
                  'fill-white': $store.state.layout.layoutMode == 'dark'
                }"
              ></eva-icon>
            </a>
            <ul class="dropdown-menu dropdown-menu-end shadow">
              <li>
                <a
                  href="#"
                  class="dropdown-item"
                  onclick="return false"
                  @click="actualizar()"
                  v-if="!bandera_spinner"
                >
                  <i class="mdi mdi-content-save text-success me-1"></i>
                  Actualizar
                </a>
                <span class="dropdown-item disabled" v-if="bandera_spinner">
                  <i class="mdi mdi-loading mdi-spin me-1"></i>
                  Actualizando...
                </span>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  onclick="return false;"
                  @click="$router.go(-1)"
                >
                  <i class="mdi mdi-close text-secondary me-1"></i>
                  Cerrar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Cuerpo de la tarjeta -->
      <div class="card-body p-4">
        <!-- Spinner de carga inicial -->
        <div v-if="cargando_datos" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="text-muted mt-2 font-size-14">Cargando plantilla y configuración de factura...</p>
        </div>

        <div v-else>
          <!-- SECCIÓN 1: Variables Disponibles y Escala de Impresión -->
          <div class="row g-4 mb-4">
            <!-- Columna de Variables Disponibles -->
            <div class="col-lg-8 col-12">
              <div class="p-3 bg-light rounded border h-100">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h5 class="text-primary font-size-14 mb-0 d-flex align-items-center">
                    <i class="mdi mdi-code-tags text-primary me-2 font-size-18"></i>
                    Variables Disponibles
                  </h5>
                  <small class="text-muted font-size-12">
                    <i class="mdi mdi-cursor-default-click-outline me-1"></i>
                    Haz clic en una variable para copiarla
                  </small>
                </div>

                <!-- Grupo: Datos de la Empresa -->
                <div class="mb-2">
                  <span class="text-muted font-size-12 fw-bold d-block mb-1">
                    <i class="mdi mdi-domain me-1"></i>Datos de la Empresa:
                  </span>
                  <span
                    class="badge badge-variable bg-soft-primary text-primary me-1 mb-1 p-2 cursor-pointer"
                    @click="copiarVariable('$nombre_empresa$')"
                    title="Copiar $nombre_empresa$"
                  >
                    <i class="mdi mdi-content-copy me-1 font-size-11"></i>$nombre_empresa$
                  </span>
                </div>

                <!-- Grupo: Datos del Cliente -->
                <div class="mb-2">
                  <span class="text-muted font-size-12 fw-bold d-block mb-1">
                    <i class="mdi mdi-account-outline me-1"></i>Datos del Cliente:
                  </span>
                  <div class="d-flex flex-wrap gap-1">
                    <span
                      v-for="(campo, index) in campos"
                      :key="`campo-${index}`"
                      class="badge badge-variable bg-soft-info text-info me-1 mb-1 p-2 cursor-pointer"
                      @click="copiarVariable(campo.codigo)"
                      :title="`Copiar ${campo.codigo} (${campo.campo})`"
                    >
                      <i class="mdi mdi-content-copy me-1 font-size-11"></i>{{ campo.codigo }}
                      <sup v-if="campo.alias" class="text-muted ms-1">({{ campo.alias }})</sup>
                    </span>
                  </div>
                </div>

                <!-- Grupo: Datos de la Factura -->
                <div class="mb-2">
                  <span class="text-muted font-size-12 fw-bold d-block mb-1">
                    <i class="mdi mdi-receipt me-1"></i>Datos de la Factura:
                  </span>
                  <div class="d-flex flex-wrap gap-1">
                    <span
                      v-for="(varFactura, idx) in variablesFactura"
                      :key="`vf-${idx}`"
                      class="badge badge-variable bg-soft-success text-success me-1 mb-1 p-2 cursor-pointer"
                      @click="copiarVariable(varFactura)"
                      :title="`Copiar ${varFactura}`"
                    >
                      <i class="mdi mdi-content-copy me-1 font-size-11"></i>{{ varFactura }}
                    </span>
                  </div>
                </div>

                <!-- Grupo: Tablas Dinámicas -->
                <div>
                  <span class="text-muted font-size-12 fw-bold d-block mb-1">
                    <i class="mdi mdi-table-large me-1"></i>Tablas Dinámicas:
                  </span>
                  <div class="d-flex flex-wrap gap-1">
                    <span
                      v-for="(varTabla, idx) in variablesTablas"
                      :key="`vt-${idx}`"
                      class="badge badge-variable bg-soft-warning text-dark me-1 mb-1 p-2 cursor-pointer"
                      @click="copiarVariable(varTabla)"
                      :title="`Copiar ${varTabla}`"
                    >
                      <i class="mdi mdi-content-copy me-1 font-size-11"></i>{{ varTabla }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Columna de Tamaño de Impresión (Escala y Simulación de Documento) -->
            <div class="col-lg-4 col-12">
              <div class="p-3 bg-light rounded border h-100 d-flex flex-column justify-content-between">
                <!-- 1. Encabezado de la Sección -->
                <div>
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <h5 class="text-primary font-size-14 mb-0 d-flex align-items-center">
                      <i class="mdi mdi-printer-settings text-primary me-2 font-size-18"></i>
                      Tamaño de Impresión
                    </h5>
                    <span class="badge bg-primary font-size-13 px-2 py-1 shadow-sm">
                      {{ ajustes.tamano_factura }}% escala
                    </span>
                  </div>
                  <p class="text-muted font-size-12 mb-2">
                    Previsualización de la escala y ajuste porcentual de la factura al imprimirse o generar PDF.
                  </p>
                </div>

                <!-- 2. Simulación Visual Interactiva del Documento (Al centro, aprovechando el espacio) -->
                <div class="my-2 flex-grow-1 d-flex flex-column">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="text-muted font-size-12 fw-bold d-flex align-items-center">
                      <i class="mdi mdi-file-eye-outline me-1 text-primary"></i>
                      Simulación en Hoja
                    </span>
                    <small class="text-muted font-size-11">
                      Escala visual: <strong>{{ Math.round(factorEscalaSimulada * 100) }}%</strong>
                    </small>
                  </div>

                  <!-- Mesa / Área de Impresión que llena el espacio -->
                  <div class="simulacion-papel-container position-relative rounded overflow-hidden d-flex align-items-center justify-content-center p-2 border flex-grow-1">
                    <!-- Hoja de papel simulada con transformación de escala reactiva -->
                    <div
                      class="simulacion-hoja shadow bg-white p-2"
                      :style="{
                        transform: `scale(${factorEscalaSimulada})`,
                        transformOrigin: 'center center'
                      }"
                    >
                      <!-- Miniatura realista y esquemática de la factura (Sin precios) -->
                      <div class="mini-factura">
                        <!-- Cabecera de la factura -->
                        <div class="d-flex justify-content-between align-items-center border-bottom pb-1 mb-1">
                          <span class="mini-logo">ARGUS BLACK</span>
                          <span class="mini-badge-factura">FACTURA</span>
                        </div>

                        <!-- Datos del Cliente (Placeholders esquemáticos) -->
                        <div class="mini-cliente mb-1">
                          <div class="mini-line w-75 mb-1 bg-secondary opacity-50"></div>
                          <div class="mini-line w-50 bg-secondary opacity-25"></div>
                        </div>

                        <!-- Mini Tabla de Partidas (Sin precios explícitos) -->
                        <div class="mini-table mb-1">
                          <div class="mini-table-header d-flex justify-content-between">
                            <span style="width: 20%;">Cant.</span>
                            <span style="width: 50%;">Descripción</span>
                            <span style="width: 30%; text-align: right;">Importe</span>
                          </div>
                          <div class="mini-table-row d-flex justify-content-between align-items-center">
                            <span style="width: 20%;">1</span>
                            <div class="mini-line w-75 bg-secondary opacity-50"></div>
                            <div class="mini-line w-50 bg-secondary opacity-50 ms-auto"></div>
                          </div>
                          <div class="mini-table-row d-flex justify-content-between align-items-center">
                            <span style="width: 20%;">1</span>
                            <div class="mini-line w-50 bg-secondary opacity-50"></div>
                            <div class="mini-line w-50 bg-secondary opacity-50 ms-auto"></div>
                          </div>
                          <div class="mini-table-row d-flex justify-content-between align-items-center">
                            <span style="width: 20%;">1</span>
                            <div class="mini-line w-65 bg-secondary opacity-50"></div>
                            <div class="mini-line w-50 bg-secondary opacity-50 ms-auto"></div>
                          </div>
                        </div>

                        <!-- Mini Totales Esquemáticos (Sin precios numéricos) -->
                        <div class="d-flex justify-content-end">
                          <div class="mini-totales text-end" style="width: 55%;">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                              <span class="text-muted" style="font-size: 6px;">Subtotal:</span>
                              <div class="mini-line w-50 bg-secondary opacity-50"></div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="fw-bold text-primary" style="font-size: 6.5px;">TOTAL:</span>
                              <div class="mini-line w-50 bg-primary opacity-75"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 3. Control Deslizante (Slider colocado abajo) -->
                <div class="mt-2 pt-2 border-top">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="text-muted font-size-12 fw-bold">Ajustar Escala:</span>
                    <span class="text-primary font-size-12 fw-bold">{{ ajustes.tamano_factura }}%</span>
                  </div>

                  <!-- Slider -->
                  <div class="px-1">
                    <Slider v-model="ajustes.tamano_factura" :min="1" :max="100" />
                  </div>
                  <div class="d-flex justify-content-between align-items-center mt-1">
                    <small class="text-muted font-size-11">1% (Mín)</small>
                    <small class="text-muted font-size-11 fw-bold text-primary">Estándar: 4% - 10%</small>
                    <small class="text-muted font-size-11">100% (Máx)</small>
                  </div>

                  <!-- Presets rápidos para aprovechar el espacio -->
                  <div class="d-flex justify-content-center gap-1 mt-2 flex-wrap">
                    <button
                      type="button"
                      class="btn btn-sm py-0 px-2 font-size-11"
                      :class="ajustes.tamano_factura == 4 ? 'btn-primary' : 'btn-outline-secondary'"
                      @click="ajustes.tamano_factura = 4"
                    >
                      4% (Estándar)
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm py-0 px-2 font-size-11"
                      :class="ajustes.tamano_factura == 10 ? 'btn-primary' : 'btn-outline-secondary'"
                      @click="ajustes.tamano_factura = 10"
                    >
                      10%
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm py-0 px-2 font-size-11"
                      :class="ajustes.tamano_factura == 25 ? 'btn-primary' : 'btn-outline-secondary'"
                      @click="ajustes.tamano_factura = 25"
                    >
                      25%
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm py-0 px-2 font-size-11"
                      :class="ajustes.tamano_factura == 50 ? 'btn-primary' : 'btn-outline-secondary'"
                      @click="ajustes.tamano_factura = 50"
                    >
                      50%
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm py-0 px-2 font-size-11"
                      :class="ajustes.tamano_factura == 100 ? 'btn-primary' : 'btn-outline-secondary'"
                      @click="ajustes.tamano_factura = 100"
                    >
                      100%
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr class="my-4 text-muted opacity-25" />

          <!-- SECCIÓN 2: Editor WYSIWYG de la Plantilla -->
          <div class="mb-5">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5 class="text-primary font-size-15 mb-0 d-flex align-items-center">
                <i class="mdi mdi-file-document-edit-outline me-2 font-size-18"></i>
                Diseño Visual de la Plantilla de Factura
              </h5>
              <button
                class="btn btn-outline-primary btn-sm d-flex align-items-center shadow-sm"
                @click="generarPlantilla()"
              >
                <i class="mdi mdi-file-restore-outline me-1 font-size-15"></i>
                Cargar plantilla por defecto
              </button>
            </div>

            <!-- Editor Aislado en Iframe -->
            <div class="border rounded shadow-sm bg-white overflow-hidden">
              <CmpEditorIframe
                ref="editorFactura"
                v-model="plantillas.factura.contenido"
                :movil="movil"
                height="650px"
              />
            </div>
          </div>

          <hr class="my-4 text-muted opacity-25" />

          <!-- SECCIÓN 3: Configuración de Tablas y Columnas -->
          <div class="mb-4">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-table-cog me-2 font-size-18"></i>
              Configuración de Columnas y Tablas
            </h5>
            <p class="text-muted font-size-13 mb-4">
              Configura los nombres (alias), la visibilidad y el orden de las columnas que se imprimirán en las tablas de la factura.
            </p>

            <!-- 3.1 Tabla de Partidas de Factura -->
            <div class="card border shadow-none mb-4">
              <div class="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center">
                <span class="fw-bold font-size-14 text-dark d-flex align-items-center">
                  <i class="mdi mdi-format-list-numbered text-primary me-2"></i>
                  Tabla de Partidas de Factura <code>$partidas_factura$</code>
                </span>
                <button
                  class="btn btn-sm btn-outline-secondary d-flex align-items-center py-1 px-2"
                  @click="restablecerColumnasPartidasFactura()"
                >
                  <i class="mdi mdi-restore me-1"></i>
                  Restablecer
                </button>
              </div>
              <div class="card-body p-3">
                <div class="table-responsive">
                  <TblColumnasPartidasFactura :columnas-partidas-factura.sync="ajustes.columnas_partidas_factura" />
                </div>
              </div>
            </div>

            <!-- 3.2 Cargos y Descuentos de Partidas -->
            <div class="row g-3 mb-4">
              <!-- Cargos de Partidas -->
              <div class="col-lg-6 col-12">
                <div class="card border shadow-none h-100 mb-0">
                  <div class="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center">
                    <span class="fw-bold font-size-13 text-dark d-flex align-items-center">
                      <i class="mdi mdi-plus-circle-outline text-success me-2"></i>
                      Cargos de las Partidas
                    </span>
                    <button
                      class="btn btn-sm btn-outline-secondary d-flex align-items-center py-1 px-2"
                      @click="restablecerColumnasCargosPartidasFactura()"
                    >
                      <i class="mdi mdi-restore me-1"></i>
                      Restablecer
                    </button>
                  </div>
                  <div class="card-body p-3">
                    <div class="table-responsive">
                      <TblColumnasCargosPartidasFactura :columnasCargosPartidasFactura.sync="ajustes.columnas_cargos_partidas_factura" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Descuentos de Partidas -->
              <div class="col-lg-6 col-12">
                <div class="card border shadow-none h-100 mb-0">
                  <div class="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center">
                    <span class="fw-bold font-size-13 text-dark d-flex align-items-center">
                      <i class="mdi mdi-minus-circle-outline text-danger me-2"></i>
                      Descuentos de las Partidas
                    </span>
                    <button
                      class="btn btn-sm btn-outline-secondary d-flex align-items-center py-1 px-2"
                      @click="restablecerColumnasDescuentosPartidasFactura()"
                    >
                      <i class="mdi mdi-restore me-1"></i>
                      Restablecer
                    </button>
                  </div>
                  <div class="card-body p-3">
                    <div class="table-responsive">
                      <TblColumnasDescuentosPartidasFactura :columnasDescuentosPartidasFactura.sync="ajustes.columnas_descuentos_partidas_factura" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 3.3 Cargos y Descuentos Globales -->
            <div class="row g-3 mb-4">
              <!-- Cargos Globales -->
              <div class="col-lg-6 col-12">
                <div class="card border shadow-none h-100 mb-0">
                  <div class="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center">
                    <span class="fw-bold font-size-13 text-dark d-flex align-items-center">
                      <i class="mdi mdi-cash-plus text-primary me-2"></i>
                      Cargos Globales <code>$cargos_globales$</code>
                    </span>
                    <button
                      class="btn btn-sm btn-outline-secondary d-flex align-items-center py-1 px-2"
                      @click="restablecerColumnasCargosGlobalesFactura()"
                    >
                      <i class="mdi mdi-restore me-1"></i>
                      Restablecer
                    </button>
                  </div>
                  <div class="card-body p-3">
                    <div class="table-responsive">
                      <TblColumnasCargosGlobalesFactura :columnasCargosGlobalesFactura.sync="ajustes.columnas_cargos_globales_factura" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Descuentos Globales -->
              <div class="col-lg-6 col-12">
                <div class="card border shadow-none h-100 mb-0">
                  <div class="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center">
                    <span class="fw-bold font-size-13 text-dark d-flex align-items-center">
                      <i class="mdi mdi-cash-minus text-danger me-2"></i>
                      Descuentos Globales <code>$descuentos_globales$</code>
                    </span>
                    <button
                      class="btn btn-sm btn-outline-secondary d-flex align-items-center py-1 px-2"
                      @click="restablecerColumnasDescuentosGlobalesFactura()"
                    >
                      <i class="mdi mdi-restore me-1"></i>
                      Restablecer
                    </button>
                  </div>
                  <div class="card-body p-3">
                    <div class="table-responsive">
                      <TblColumnasDescuentosGlobalesFactura :columnasDescuentosGlobalesFactura.sync="ajustes.columnas_descuentos_globales_factura" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 3.4 Desglose de Abonos -->
            <div class="card border shadow-none">
              <div class="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center">
                <span class="fw-bold font-size-13 text-dark d-flex align-items-center">
                  <i class="mdi mdi-cash-multiple text-success me-2"></i>
                  Desglose de Abonos <code>$desglose_abonos$</code>
                </span>
                <button
                  class="btn btn-sm btn-outline-secondary d-flex align-items-center py-1 px-2"
                  @click="restablecerColumnasDesgloseAbonosFactura()"
                >
                  <i class="mdi mdi-restore me-1"></i>
                  Restablecer
                </button>
              </div>
              <div class="card-body p-3">
                <div class="col-lg-6 col-12">
                  <div class="table-responsive">
                    <TblColumnasDesgloseAbonosFactura :columnasDesgloseAbonosFactura.sync="ajustes.columnas_desglose_abonos_factura" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-right">
      <div class="btn-group">
        <button 
          class="btn btn-secondary px-3"
          @click="$router.go(-1)"
        >
          <i class="mdi mdi-chevron-left me-1"></i>
          Atras
        </button>
        <button 
          class="btn btn-success px-4" 
          @click="actualizar()" 
          :disabled="bandera_spinner || cargando_ajustes"
        >
          <i
            class="mdi"
            :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
          ></i>
          {{ bandera_spinner ? 'Guardando...' : 'Actualizar' }}
        </button>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main"
import SistemaSrv from '@/services/SistemaSrv.js'
import PlantillaSrv from '@/services/PlantillaSrv.js'
import VistasCampos from '@/services/VistasCampos.js'
import CmpTabs from '../CmpTabs.vue'
import TblColumnasPartidasFactura from './TblColumnasPartidasFactura.vue'
import TblColumnasCargosPartidasFactura from './TblColumnasCargosPartidasFactura.vue'
import TblColumnasDescuentosPartidasFactura from './TblColumnasDescuentosPartidasFactura.vue'
import TblColumnasCargosGlobalesFactura from './TblColumnasCargosGlobalesFactura.vue'
import TblColumnasDescuentosGlobalesFactura from './TblColumnasDescuentosGlobalesFactura.vue'
import TblColumnasDesgloseAbonosFactura from './TblColumnasDesgloseAbonosFactura.vue'
import CmpEditorIframe from './CmpEditorIframe.vue'

import Slider from "@vueform/slider";
import axios from 'axios'

export default {
  name: 'PlantillaFactura',
  components: {
    Layout,
    CmpTabs,
    Slider,
    CmpEditorIframe,
    TblColumnasPartidasFactura,
    TblColumnasCargosPartidasFactura,
    TblColumnasDescuentosPartidasFactura,
    TblColumnasCargosGlobalesFactura,
    TblColumnasDescuentosGlobalesFactura,
    TblColumnasDesgloseAbonosFactura
  },
  data() {
    return {
      cargando_datos: false,
      bandera_spinner: false,
      movil: false,
      ajustes: {
        tamano_factura: 4,
        columnas_partidas_factura: [],
        columnas_cargos_partidas_factura: [],
        columnas_descuentos_partidas_factura: [],
        columnas_cargos_globales_factura: [],
        columnas_descuentos_globales_factura: [],
        columnas_desglose_abonos_factura: []
      },
      plantillas: {
        factura: {
          nombre: '',
          contenido: ''
        }
      },
      variablesFactura: [
        '$numero_serie$',
        '$fecha_expedicion$',
        '$fecha_para_pago$',
        '$fecha_vencimiento$',
        '$id_contrato$',
        '$inicio_periodo$',
        '$fin_periodo$',
        '$nota_factura$',
        '$sub_total$',
        '$total_cargos_globales$',
        '$total_descuentos_globales$',
        '$porcentaje_impuestos$',
        '$impuestos$',
        '$total_factura$'
      ],
      variablesTablas: [
        '$partidas_factura$',
        '$cargos_globales$',
        '$descuentos_globales$',
        '$desglose_abonos$'
      ],
      campos: [
        { campo: 'Número de cliente', alias: '', codigo: '$numero_cliente$' },
        { campo: 'ID', alias: '', codigo: '$id_cliente$' },
        { campo: 'Nombre', alias: '', codigo: '$nombre$' },
        { campo: 'Apellido paterno', alias: '', codigo: '$apellido_paterno$' },
        { campo: 'Apellido materno', alias: '', codigo: '$apellido_materno$' },
        { campo: 'RFC', alias: '', codigo: '$rfc$' },
        { campo: 'Sexo', alias: '', codigo: '$sexo$' },
        { campo: 'Tipo de cliente', alias: '', codigo: '$tipo_cliente$' },
        { campo: 'Estado', alias: '', codigo: '$estado$' },
        { campo: 'Calle', alias: '', codigo: '$calle$' },
        { campo: 'N° ext', alias: '', codigo: '$numero_exterior$' },
        { campo: 'N° int', alias: '', codigo: '$numero_interior$' },
        { campo: 'Colonia', alias: '', codigo: '$colonia$' },
        { campo: 'Delegación o Municipio', alias: '', codigo: '$delegacion$' },
        { campo: 'Código postal', alias: '', codigo: '$codigo_postal$' },
        { campo: 'Estado de residencia', alias: '', codigo: '$estado_residencia$' },
        { campo: 'País', alias: '', codigo: '$pais$' },
        { campo: 'Correo electrónico', alias: '', codigo: '$correo_electronico$' }
      ]
    }
  },

  computed: {
    factorEscalaSimulada() {
      const val = Number(this.ajustes.tamano_factura) || 4
      // Cálculo proporcional suave:
      // Con 1% -> 0.45, con 4% -> 0.55 (estándar), con 10% -> 0.65, con 50% -> 0.95, con 100% -> 1.25
      const escala = 0.45 + (val / 100) * 0.8
      return Math.min(Math.max(escala, 0.45), 1.25).toFixed(2)
    }
  },

  created() {
    var self = this

    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i) ||
      window.innerWidth <= 780
    ) {
      self.movil = true
    }

    self.cargarDatosIniciales()
  },

  methods: {
    cargarDatosIniciales() {
      let self = this
      self.cargando_datos = true

      Promise.all([
        self.refrescarAjustes(),
        self.refrescarPlantilla(),
        self.refrescarCampos()
      ]).finally(() => {
        self.cargando_datos = false
      })
    },

    copiarVariable(codigo) {
      if (!codigo) return
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(() => {
          if (window.iu && window.iu.msg) {
            window.iu.msg.info(`Copiado: ${codigo}`)
          }
        }).catch(() => {
          if (window.iu && window.iu.msg) {
            window.iu.msg.info(codigo)
          }
        })
      } else {
        if (window.iu && window.iu.msg) {
          window.iu.msg.info(codigo)
        }
      }
    },

    actualizar() {
      let self = this
      let ajustes = Object.assign({}, self.ajustes)

      self.bandera_spinner = true

      let prom1 = SistemaSrv.actualizar(ajustes)
      let prom2 = PlantillaSrv.actualizar('factura', self.plantillas.factura.contenido)

      axios.all([prom1, prom2]).then(() => {
        if (window.iu && window.iu.msg) {
          window.iu.msg.success('Se actualizaron los datos de la plantilla de factura correctamente')
        }
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo actualizar la configuración'
        if (window.iu && window.iu.msg) {
          window.iu.msg.error(mensaje)
        }
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },

    generarPlantilla() {
      let self = this
      PlantillaSrv.plantillaPorDefectoJSON('factura').then(response => {
        let factura = response.data
        Object.assign(self.plantillas.factura, factura)
        if (self.$refs.editorFactura) {
          self.$refs.editorFactura.setCode(factura.contenido || '')
        }
        if (window.iu && window.iu.msg) {
          window.iu.msg.info('Plantilla por defecto cargada')
        }
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar la plantilla por defecto'
        if (window.iu && window.iu.msg) {
          window.iu.msg.error(mensaje)
        }
        console.log(error)
      })
    },

    refrescarCampos() {
      let self = this
      return VistasCampos.vistasCamposJSON().then(response => {
        let campos = response.data || []
        campos = campos.filter(campo => campo.id_vista == 36)

        campos.forEach(campo1 => {
          let index = self.campos.findIndex(campo2 => campo1.campo == campo2.campo)
          if (index !== -1) {
            self.campos[index].alias = campo1.alias
          }
        })
      }).catch(e => {
        console.log('Error al obtener campos:', e)
      })
    },

    refrescarAjustes() {
      let self = this
      let nombresAjustes = Object.keys(self.ajustes)

      return SistemaSrv.ajustes(nombresAjustes).then(response => {
        let ajustes = response.data || {}
        self.ajustes.tamano_factura = Number(ajustes.tamano_factura) || 4

        nombresAjustes.forEach(na => {
          try {
            if (ajustes[na]) {
              self.ajustes[na] = JSON.parse(ajustes[na])
            }
          } catch (e) {
            // Valor no JSON
          }
        })
      }).catch(e => {
        console.log('Error al obtener ajustes:', e)
      })
    },

    refrescarPlantilla() {
      let self = this

      return PlantillaSrv.plantillaJSON('factura').then(response => {
        let factura = response.data || {}
        Object.assign(self.plantillas.factura, factura)
        if (self.$refs.editorFactura) {
          self.$refs.editorFactura.setCode(factura.contenido || '')
        }
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar la plantilla de factura'
        if (window.iu && window.iu.msg) {
          window.iu.msg.error(mensaje)
        }
        console.log(error)
      })
    },

    restablecerColumnasCargosGlobalesFactura() {
      let self = this
      SistemaSrv.valorPorDefectoAjuste('columnas_cargos_globales_factura').then(response => {
        self.ajustes.columnas_cargos_globales_factura = response.data
        if (window.iu && window.iu.msg) {
          window.iu.msg.success('Columnas de cargos globales restablecidas')
        }
      })
    },

    restablecerColumnasDesgloseAbonosFactura() {
      let self = this
      SistemaSrv.valorPorDefectoAjuste('columnas_desglose_abonos_factura').then(response => {
        self.ajustes.columnas_desglose_abonos_factura = response.data
        if (window.iu && window.iu.msg) {
          window.iu.msg.success('Columnas de desglose de abonos restablecidas')
        }
      })
    },

    restablecerColumnasDescuentosGlobalesFactura() {
      let self = this
      SistemaSrv.valorPorDefectoAjuste('columnas_descuentos_globales_factura').then(response => {
        self.ajustes.columnas_descuentos_globales_factura = response.data
        if (window.iu && window.iu.msg) {
          window.iu.msg.success('Columnas de descuentos globales restablecidas')
        }
      })
    },

    restablecerColumnasCargosPartidasFactura() {
      let self = this
      SistemaSrv.valorPorDefectoAjuste('columnas_cargos_partidas_factura').then(response => {
        self.ajustes.columnas_cargos_partidas_factura = response.data
        if (window.iu && window.iu.msg) {
          window.iu.msg.success('Columnas de cargos de partidas restablecidas')
        }
      })
    },

    restablecerColumnasDescuentosPartidasFactura() {
      let self = this
      SistemaSrv.valorPorDefectoAjuste('columnas_descuentos_partidas_factura').then(response => {
        self.ajustes.columnas_descuentos_partidas_factura = response.data
        if (window.iu && window.iu.msg) {
          window.iu.msg.success('Columnas de descuentos de partidas restablecidas')
        }
      })
    },

    restablecerColumnasPartidasFactura() {
      let self = this
      SistemaSrv.valorPorDefectoAjuste('columnas_partidas_factura').then(response => {
        self.ajustes.columnas_partidas_factura = response.data
        if (window.iu && window.iu.msg) {
          window.iu.msg.success('Columnas de partidas restablecidas')
        }
      })
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.badge-variable {
  transition: all 0.15s ease-in-out;
  font-weight: 500;
  user-select: none;
}

.badge-variable:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  filter: brightness(0.95);
}

.badge-variable:active {
  transform: translateY(0);
}

.bg-soft-primary {
  background-color: rgba(59, 118, 225, 0.12) !important;
}

.bg-soft-info {
  background-color: rgba(23, 162, 184, 0.12) !important;
}

.bg-soft-success {
  background-color: rgba(99, 173, 111, 0.15) !important;
}

.bg-soft-warning {
  background-color: rgba(249, 194, 85, 0.2) !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

/* Estilos de la Simulación de Documento Impreso */
.simulacion-papel-container {
  background-color: #eef2f7;
  background-image: radial-gradient(#d5dbe5 1.2px, transparent 1.2px);
  background-size: 11px 11px;
  min-height: 250px;
  border-color: #dbe2ea !important;
}

.simulacion-hoja {
  width: 180px;
  height: 245px;
  border-radius: 3px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12) !important;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  font-size: 7.5px;
  line-height: 1.25;
  user-select: none;
}

.mini-factura {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.mini-logo {
  font-weight: 800;
  font-size: 7.5px;
  color: #3b76e1;
  letter-spacing: 0.5px;
}

.mini-badge-factura {
  font-weight: 700;
  font-size: 7px;
  color: #495057;
  background-color: #f1f5f9;
  padding: 1px 3px;
  border-radius: 2px;
}

.mini-line {
  height: 3px;
  border-radius: 2px;
}

.mini-table {
  border: 1px solid #e9ecef;
  border-radius: 2px;
  font-size: 6.5px;
}

.mini-table-header {
  background-color: #f8fafc;
  font-weight: 700;
  padding: 2px 4px;
  border-bottom: 1px solid #e9ecef;
  color: #475569;
}

.mini-table-row {
  padding: 2px 4px;
  border-bottom: 1px dashed #f1f5f9;
  color: #334155;
}

.mini-totales {
  font-size: 7px;
}
</style>